import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { getNextHandlerTag } from "../handlersRegistry";
import { isRemoteDebuggingEnabled } from "../../utils";
export var CALLBACK_TYPE = {
    UNDEFINED: 0,
    BEGAN: 1,
    START: 2,
    UPDATE: 3,
    CHANGE: 4,
    END: 5,
    FINALIZE: 6,
    TOUCHES_DOWN: 7,
    TOUCHES_MOVE: 8,
    TOUCHES_UP: 9,
    TOUCHES_CANCELLED: 10
};
export var Gesture = function Gesture() {
    "use strict";
    _class_call_check(this, Gesture);
};
var nextGestureId = 0;
export var BaseGesture = /*#__PURE__*/ function(Gesture) {
    "use strict";
    _inherits(BaseGesture, Gesture);
    var _super = _create_super(BaseGesture);
    function BaseGesture() {
        _class_call_check(this, BaseGesture);
        var _this;
        _this = _super.call(this);
        _define_property(_assert_this_initialized(_this), "gestureId", -1);
        _define_property(_assert_this_initialized(_this), "handlerTag", -1);
        _define_property(_assert_this_initialized(_this), "handlerName", "");
        _define_property(_assert_this_initialized(_this), "config", {});
        _define_property(_assert_this_initialized(_this), "handlers", {
            gestureId: -1,
            handlerTag: -1,
            isWorklet: []
        });
        // Used to check whether the gesture config has been updated when wrapping it
        // with `useMemo`. Since every config will have a unique id, when the dependencies
        // don't change, the config won't be recreated and the id will stay the same.
        // If the id is different, it means that the config has changed and the gesture
        // needs to be updated.
        _this.gestureId = nextGestureId++;
        _this.handlers.gestureId = _this.gestureId;
        return _this;
    }
    _create_class(BaseGesture, [
        {
            key: "addDependency",
            value: function addDependency(key, gesture) {
                var value = this.config[key];
                this.config[key] = value ? Array().concat(value, gesture) : [
                    gesture
                ];
            }
        },
        {
            key: "withRef",
            value: function withRef(ref) {
                this.config.ref = ref;
                return this;
            }
        },
        {
            key: "isWorklet",
            value: // eslint-disable-next-line @typescript-eslint/ban-types
            function isWorklet(callback) {
                //@ts-ignore if callback is a worklet, the property will be available, if not then the check will return false
                return callback.__workletHash !== undefined;
            }
        },
        {
            key: "onBegin",
            value: function onBegin(callback) {
                this.handlers.onBegin = callback;
                this.handlers.isWorklet[CALLBACK_TYPE.BEGAN] = this.isWorklet(callback);
                return this;
            }
        },
        {
            key: "onStart",
            value: function onStart(callback) {
                this.handlers.onStart = callback;
                this.handlers.isWorklet[CALLBACK_TYPE.START] = this.isWorklet(callback);
                return this;
            }
        },
        {
            key: "onEnd",
            value: function onEnd(callback) {
                this.handlers.onEnd = callback;
                //@ts-ignore if callback is a worklet, the property will be available, if not then the check will return false
                this.handlers.isWorklet[CALLBACK_TYPE.END] = this.isWorklet(callback);
                return this;
            }
        },
        {
            key: "onFinalize",
            value: function onFinalize(callback) {
                this.handlers.onFinalize = callback;
                //@ts-ignore if callback is a worklet, the property will be available, if not then the check will return false
                this.handlers.isWorklet[CALLBACK_TYPE.FINALIZE] = this.isWorklet(callback);
                return this;
            }
        },
        {
            key: "onTouchesDown",
            value: function onTouchesDown(callback) {
                this.config.needsPointerData = true;
                this.handlers.onTouchesDown = callback;
                this.handlers.isWorklet[CALLBACK_TYPE.TOUCHES_DOWN] = this.isWorklet(callback);
                return this;
            }
        },
        {
            key: "onTouchesMove",
            value: function onTouchesMove(callback) {
                this.config.needsPointerData = true;
                this.handlers.onTouchesMove = callback;
                this.handlers.isWorklet[CALLBACK_TYPE.TOUCHES_MOVE] = this.isWorklet(callback);
                return this;
            }
        },
        {
            key: "onTouchesUp",
            value: function onTouchesUp(callback) {
                this.config.needsPointerData = true;
                this.handlers.onTouchesUp = callback;
                this.handlers.isWorklet[CALLBACK_TYPE.TOUCHES_UP] = this.isWorklet(callback);
                return this;
            }
        },
        {
            key: "onTouchesCancelled",
            value: function onTouchesCancelled(callback) {
                this.config.needsPointerData = true;
                this.handlers.onTouchesCancelled = callback;
                this.handlers.isWorklet[CALLBACK_TYPE.TOUCHES_CANCELLED] = this.isWorklet(callback);
                return this;
            }
        },
        {
            key: "enabled",
            value: function enabled(enabled) {
                this.config.enabled = enabled;
                return this;
            }
        },
        {
            key: "shouldCancelWhenOutside",
            value: function shouldCancelWhenOutside(value) {
                this.config.shouldCancelWhenOutside = value;
                return this;
            }
        },
        {
            key: "hitSlop",
            value: function hitSlop(hitSlop) {
                this.config.hitSlop = hitSlop;
                return this;
            }
        },
        {
            key: "activeCursor",
            value: function activeCursor(activeCursor) {
                this.config.activeCursor = activeCursor;
                return this;
            }
        },
        {
            key: "runOnJS",
            value: function runOnJS(runOnJS) {
                this.config.runOnJS = runOnJS;
                return this;
            }
        },
        {
            key: "simultaneousWithExternalGesture",
            value: function simultaneousWithExternalGesture() {
                for(var _len = arguments.length, gestures = new Array(_len), _key = 0; _key < _len; _key++){
                    gestures[_key] = arguments[_key];
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = gestures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var gesture = _step.value;
                        this.addDependency("simultaneousWith", gesture);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return this;
            }
        },
        {
            key: "requireExternalGestureToFail",
            value: function requireExternalGestureToFail() {
                for(var _len = arguments.length, gestures = new Array(_len), _key = 0; _key < _len; _key++){
                    gestures[_key] = arguments[_key];
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = gestures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var gesture = _step.value;
                        this.addDependency("requireToFail", gesture);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return this;
            }
        },
        {
            key: "withTestId",
            value: function withTestId(id) {
                this.config.testId = id;
                return this;
            }
        },
        {
            key: "cancelsTouchesInView",
            value: function cancelsTouchesInView(value) {
                this.config.cancelsTouchesInView = value;
                return this;
            }
        },
        {
            key: "initialize",
            value: function initialize() {
                this.handlerTag = getNextHandlerTag();
                this.handlers = _object_spread_props(_object_spread({}, this.handlers), {
                    handlerTag: this.handlerTag
                });
                if (this.config.ref) {
                    this.config.ref.current = this;
                }
            }
        },
        {
            key: "toGestureArray",
            value: function toGestureArray() {
                return [
                    this
                ];
            }
        },
        {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            key: "prepare",
            value: function prepare() {}
        },
        {
            key: "shouldUseReanimated",
            get: function get() {
                // use Reanimated when runOnJS isn't set explicitly,
                // and all defined callbacks are worklets,
                // and remote debugging is disabled
                return this.config.runOnJS !== true && !this.handlers.isWorklet.includes(false) && !isRemoteDebuggingEnabled();
            }
        }
    ]);
    return BaseGesture;
}(Gesture);
export var ContinousBaseGesture = /*#__PURE__*/ function(BaseGesture) {
    "use strict";
    _inherits(ContinousBaseGesture, BaseGesture);
    var _super = _create_super(ContinousBaseGesture);
    function ContinousBaseGesture() {
        _class_call_check(this, ContinousBaseGesture);
        return _super.apply(this, arguments);
    }
    _create_class(ContinousBaseGesture, [
        {
            key: "onUpdate",
            value: function onUpdate(callback) {
                this.handlers.onUpdate = callback;
                this.handlers.isWorklet[CALLBACK_TYPE.UPDATE] = this.isWorklet(callback);
                return this;
            }
        },
        {
            key: "onChange",
            value: function onChange(callback) {
                this.handlers.onChange = callback;
                this.handlers.isWorklet[CALLBACK_TYPE.CHANGE] = this.isWorklet(callback);
                return this;
            }
        },
        {
            key: "manualActivation",
            value: function manualActivation(manualActivation) {
                this.config.manualActivation = manualActivation;
                return this;
            }
        }
    ]);
    return ContinousBaseGesture;
}(BaseGesture);
